import gql from 'graphql-tag';

export const SCHEDULING_TIME_OFF_FIELDS_FRAGMENT = gql`
  fragment SchedulingTimeOffFields on TimeOff {
    id
    dateStamp
    type
    description
    paid
    seconds
    memberId
    member {
      id
      firstName
      lastName
    }
  }
`;
